import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  CreateAudienceFromDirectMembersFulfilledAction,
  CreateAudienceFromOfficeGroupFulfilledAction,
  CreateAudienceFulfilledAction,
  LeaderAudiencesLoadFulfilledAction,
  UserNetworkLeadersListLoadFulfilledAction,
  UserNetworkLeadersListLoadMoreFulfilledAction,
} from '../../domains/leadersManagement/actions.types';

import { Audiences } from './types';

export type AudienceAction =
  | LeaderAudiencesLoadFulfilledAction
  | CreateAudienceFulfilledAction
  | CreateAudienceFromOfficeGroupFulfilledAction
  | CreateAudienceFromDirectMembersFulfilledAction
  | UserNetworkLeadersListLoadFulfilledAction
  | UserNetworkLeadersListLoadMoreFulfilledAction;

const initialState: Audiences = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<Audiences, AudienceAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'LEADER_AUDIENCES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    case 'CREATE_AUDIENCE.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    case 'CREATE_AUDIENCE_FROM_OFFICE_GROUP.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    case 'CREATE_AUDIENCE_FROM_DIRECT_MEMBERS.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    default:
      return state;
  }
};

export default reducer;
